export default __webpack_public_path__ + "img/2947b47f7a69737a1c2f408a108d100e.png";